<template>
  <v-alert
      v-if="thanks"
      type="info"
  >
    Skontrolujte si e-mail. :)
  </v-alert>

  <FormPart
      v-else
      :setItemForm="setItemForm"
      :submitData="submitData"
      @onSuccess="onSuccess"
      @onFail="onFail"
  >
    <template
        v-slot:default="{
          loading,
          errors,
          ItemForm
        }"
    >
      <v-row>
        <v-col
            cols="12"
        >
          <v-text-field
              v-model="ItemForm.plainPassword.first"
              :error-messages="errors.plainPassword?.first"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Heslo"
              :persistent-hint="true"
              hint="Minimálne 6 znakov"
              type="password"
          />
        </v-col>

        <v-col
            cols="12"
        >
          <v-text-field
              v-model="ItemForm.plainPassword.second"
              :error-messages="errors.plainPassword?.second"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Heslo znova"
              type="password"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col
            cols="12"
        >
          <v-btn
              type="submit"
              :large="true"
              :block="true"
              :loading="loading"
              :disabled="loading"
              color="primary"
          >
            <v-icon>
              mdi-cog
            </v-icon>

            Nastaviť nové heslo
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </FormPart>
</template>

<script>
  import UserNewPassword from '@/services/user-new-password'

  import FormPart from '@/components/_Part/Form'

  export default {
    name: 'Form',
    props: [
      'User'
    ],
    components: {
      FormPart
    },
    data() {
      return {
        thanks: false
      }
    },
    methods: {
      setItemForm() {
        return {
          plainPassword: {
            first: null,
            second: null
          }
        }
      },
      submitData(ItemForm) {
        return UserNewPassword
          .set({
            newPasswordToken: this.User.newPasswordToken,
            data: ItemForm
          })
      },
      onSuccess() {
        this.thanks = true
      },
      onFail() {
        this.$router.push('/new-password/request')
      }
    }
  }
</script>
